import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { CertificationsFragmentGql } from './DataQualityCertificationFragmentsGql';
import { DataQualityWarningAssetFragmentGql } from './DataQualityWarningAssetFragmentGql';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';
import { DatabaseCertificationFragmentGql } from './DatabaseCertificationFragmentGql';
import { DatabaseIconFragmentGql } from './DatabaseIconFragmentGql';
import { DatabaseServerOrPathFragmentGql } from './DatabaseServerOrPathFragmentGql';
import { TableauUserFragmentGql } from './TableauUserFragmentGql';

export const DatabasesDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment DatabasesDisplayGridRowDataFragment on Database {
  id
  name
  description
  ...DatabaseCertificationFragment
  ...CertificationsFragment
  connectionType
  luid
  vizportalId
  isGrouped
  isEmbedded
  tags {
    name
  }
  contact {
    ...TableauUserFragment
  }
  controlledPermissionsEnabled: isControlledPermissionsEnabled
  downstreamVirtualConnectionsConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  ...DatabaseIconFragment
  ...DatabaseServerOrPathFragment
  dataQualityWarnings {
    ...DataQualityWarningFragment
    ...DataQualityWarningAssetFragment
  }
}
${DatabaseCertificationFragmentGql}
${CertificationsFragmentGql}
${DatabaseServerOrPathFragmentGql}
${DatabaseIconFragmentGql}
${DataQualityWarningFragmentGql}
${DataQualityWarningAssetFragmentGql}
${TableauUserFragmentGql}
`;
